import Blockv from './MainBv.js'
export const cdnAuthedUrl = url => {
	if (url === undefined || url === null) {
		return "";
	}

	if (!url.includes("cdn.blockv.io") && !url.includes("cdndev.blockv.net")) {
		return url;
	}

	return Blockv.instance.UserManager.encodeAssetProvider(url);
};



// WEBPACK FOOTER //
// ./src/common.js